// What search engines, link previews and the browser tab show for the site as a whole. Each page's own title and
// description are with its other words. public/index.html and scripts/prerender.mjs have copies of siteDescription
// (in English, for crawlers): keep them in step.
export const meta = {
    siteDescription: 'Audio software for electronic music artists, producers, and sound designers, with documentation and support.',
    // The browser tab's title on a page with its own: {title} is the page's, {site} the site's name.
    pageTitle: '{title} – {site}'
};

export type MetaMessages = typeof meta;
